interface AvatarProps {
  initials: string;
  me?: boolean;
  title?: string;
}

export default function Avatar({ initials, me, title }: AvatarProps) {
  return (
    <span className={`avatar ${me ? "me" : ""}`} title={title || initials} aria-hidden>
      {initials.slice(0, 3)}
    </span>
  );
}
